import _classCallCheck from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/classCallCheck";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { readOnlyBinaryProperty, readOnlyProperty, frozenClass } from './immutable_class';
import { needs } from './needs';
export var EncryptedDataKey = function EncryptedDataKey(edkInput) {
  _classCallCheck(this, EncryptedDataKey);

  var providerInfo = edkInput.providerInfo,
      providerId = edkInput.providerId,
      encryptedDataKey = edkInput.encryptedDataKey,
      rawInfo = edkInput.rawInfo;
  needs(typeof providerInfo === 'string' && providerInfo && typeof providerId === 'string' && providerId && encryptedDataKey instanceof Uint8Array && encryptedDataKey.byteLength, 'Malformed encrypted data key');
  readOnlyProperty(this, 'providerInfo', providerInfo);
  readOnlyProperty(this, 'providerId', providerId);
  readOnlyBinaryProperty(this, 'encryptedDataKey', encryptedDataKey);

  if (rawInfo instanceof Uint8Array) {
    readOnlyBinaryProperty(this, 'rawInfo', rawInfo);
  } else {
    readOnlyProperty(this, 'rawInfo', undefined);
  }

  Object.setPrototypeOf(this, EncryptedDataKey.prototype);
  Object.freeze(this);
};
frozenClass(EncryptedDataKey);